module.exports = __webpack_public_path__ + "img/arrow-up-short-wide.5287fa18.svg";